import gql from 'graphql-tag';

const ProductInfoQuery = {
  actionFavoriteItem: gql`
    mutation actionFavoriteItem(
      $postponed: Boolean
      $action: String
      $objectId: Int!
      $object: String!
    ) {
      actionFavoriteItem(
        postponed: $postponed
        action: $action
        objectId: $objectId
        object: $object
      ) {
        result
        total
      }
    }
  `,

  // Если запрос если из заказов - передать orderItemId
  applyForRefund: gql`
    mutation applyForRefund(
      $id: Int!
      $paymentId: Int!
      $containerIds: [Int!] = []
      $commentIds: [Int!] = []
      $fileIds: [Int!] = []
      $orderItemId: Int = null
      $comment: String = null
      $amount: Int = 0
    ) {
      applyForRefund(
        catalogId: $id
        orderItemId: $orderItemId
        amount: $amount
        comment: $comment
        paymentTypeId: $paymentId
        fileIds: $fileIds
        commentIds: $commentIds
        containerIds: $containerIds
      ) {
        id
        order_id
        order_item_id
        orderItem {
          id
          catalog_id
          amount
          price
          availableForRefund
        }
        order {
          id
          price
        }
        amount
        total
        comment
        refund_type_id
        type {
          id
          title
          comment
        }
        date
        photos {
          id
          thumb
          big
          isVideo
          video {
            title
            file
            width
            height
            converted
          }
        }
        commentItems {
          id
          text
          weight
          active
        }
      }
    }
  `
};

export default ProductInfoQuery;
